import React, { useState, useEffect, useRef, useContext } from "react";
import one from "../assets/one.png";
import two from "../assets/two.png";
import three from "../assets/three.png";
import four from "../assets/four.png";
import five from "../assets/five.png";
import six from "../assets/six.png";
import seven from "../assets/seven.png";
import eight from "../assets/eight.png";
import ErrorScreen from "./ErrorScreen";
import errorIcon from "../assets/NoSearchResultFound1.png";
import nine from "../assets/nine.png";
import ten from "../assets/ten.png";
import premium from "../assets/Premium.png";
import rent from "../assets/Rent.png";
import default_horizontal_img from "../assets/placehoder_horizontal.png";
import default_vertical_img from "../assets/placehoder_vertical.png";
import backIcon from "../assets/back-button.png";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import AppInApp from "./AppInApp";
import $ from "jquery";
import Wrapper from "./shared/Wrapper";
import view_all from "../assets/view_all.png";
import { handleViewAll } from "./dataManager";
import { getViewAllContent } from "./dataManager";
import { getHomeSectionAppinApp } from "../services/services";
import { AppContext } from "../AppContext";

let resolution = window.RESOLUTION;
let platform = "";

const userAgent = navigator.userAgent.toLowerCase();
if (
  userAgent.includes("webos") ||
  userAgent.includes("lg") ||
  userAgent.includes("web0s")
) {
  platform = "webOS";
  resolution = "FHD";
}

let addKeyListener;
let setFocusToDefault;
let RemoveCurrentKeyListener;

// Helper function to ensure view_all items are always at the end
// const processDataWithViewAllAtEnd = (inputData) => {
//   if (!Array.isArray(inputData)) return [];

//   const processedData = inputData
//     .filter(
//       (row) =>
//         row?.layout?.device_type === 10 ||
//         row?.layout?.device_type === 11
//     )
//     .map((row) => {
//       if (!Array.isArray(row.list)) return row;

//       const viewAllItems = row.list.filter(
//         (item) => item.type_id === "view_all"
//       );
//       const otherItems = row.list.filter(
//         (item) => item.type_id !== "view_all"
//       );

//       return {
//         ...row,
//         list: [...otherItems, ...viewAllItems],
//       };
//     })
//     // ❗ Remove rows whose list is empty
//     .filter((row) => Array.isArray(row.list) && row.list.length > 0);

//   return processedData;
// };

const processDataWithViewAllAtEnd = (inputData) => {
  if (!Array.isArray(inputData)) return [];

  const processedData = inputData
    .filter((row) =>
      Array.isArray(row.layout) &&
      row.layout.some(
        (l) => l.device_type === 8 || l.device_type === 9
      )
    )
    .map((row) => {
      if (!Array.isArray(row.list)) return row;

      const viewAllItems = row.list.filter(
        (item) => item.type_id === "view_all"
      );
      const otherItems = row.list.filter(
        (item) => item.type_id !== "view_all"
      );

      return {
        ...row,
        list: [...otherItems, ...viewAllItems],
      };
    })
    .filter((row) => Array.isArray(row.list) && row.list.length > 0);

  return processedData;
};


const AppInAppListData = ({
  data: initialData,
  filterTags,
  recomenddata,
  recomenddataFeed,
  columnCount,
  rowHeight,
  rowWidth = "100%",
  columnWidth,
  columnHeight,
  thumbnailWidth,
  thumbnailHeight,
  gapX,
  gapY,
  selectionColor = "#FFFFFF",
  scrollDuration = 300,
  defaultRowCount = 1,
  horizontalScrollStartIndex = 1,
  selectionStyle,
  gridContainerX,
  gridContainerY,
  gridContainerWidth,
  gridContainerHeight,
  gridContainerBgColor,
  shouldFocus,
  navigate,
  shouldFocusToGrid,
  FocusHandler,
  callBack,
  isChild,
  navigateScreen,
  hideRowlist,
  itemDetails,
  appinappData,
}) => {
  // Process data to ensure view_all is always at end
  const [data, setData] = useState(() =>
    processDataWithViewAllAtEnd(initialData)
  );
  const [currentRowIndex, setCurrentRowIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState({ row: 0, col: 0 });
  const [scrollOffsets, setScrollOffsets] = useState({});
  const [verticalScrollOffset, setVerticalScrollOffset] = useState(0);
  const [scrolling, setScrolling] = useState(false);

  const { sourceContext, setSourceContext } = useContext(AppContext);
  const { isAppInAppData, setIsAppInAppData } = useContext(AppContext);

  const keyListenerRef = useRef(null);
  const images = [one, two, three, four, five, six, seven, eight, nine, ten];

  // Number of visible rows
  const visibleRowCount = 3;

  const [state, setState] = useState({
    griddata: null,
    isBackButtonSelected: false,
    hasBackButtonFocus: false,
  });

  const { griddata, hasBackButtonFocus } = state;

  // Update data when initialData changes
  useEffect(() => {
    const processed = processDataWithViewAllAtEnd(initialData);
    setData(processed);
    setScrollOffsets({});
    setVerticalScrollOffset(0);
  }, [initialData]);

  // Get visible column count based on playlist type
  const getColumnCount = (rowIndex) => {
    const row = data?.[rowIndex];
    if (!row) return columnCount;

    if (
      row.playlist_type === "continue_watching" ||
      row.playlist_type === "content_language" ||
      row.playlist_type === "RecommededFeed" ||
      row.playlist_type === "aggregator" ||
      row.playlist_type === "popular_genres"
    ) {
      return 4;
    }
    return columnCount;
  };

  // Get current scroll offset for a row
  const getScrollOffset = (rowIndex) => {
    return scrollOffsets[rowIndex] || 0;
  };

  // Get visible items for a row based on scroll offset
  const getVisibleItems = (rowIndex) => {
    const row = data?.[rowIndex];
    if (!row || !row.list) return [];

    const offset = getScrollOffset(rowIndex);
    const visibleCount = getColumnCount(rowIndex) + 2;
    return row.list.slice(offset, offset + visibleCount);
  };

  // Handle key down events for navigation
  const handleKeyDown = (e) => {
    if (scrolling) return;

    switch (e.keyCode) {
      case 40: // Down
        if (hasBackButtonFocus) {
          setState((prevState) => ({
            ...prevState,
            hasBackButtonFocus: false,
          }));
          setCurrentRowIndex(0);
          setSelectedIndex({ row: 0, col: 0 });
        } else {
          selectDown();
        }
        break;
      case 38: // Up
        selectUp();
        break;
      case 39: // Right
        if (hasBackButtonFocus) return;
        selectRight();
        break;
      case 37: // Left
        if (hasBackButtonFocus) return;
        selectLeft();
        break;
      case 13: // Enter/OK
        if (hasBackButtonFocus) {
          handleBack();
        } else {
          handleOk();
        }
        break;
      case 10009: // Back button
      case 8: // Backspace
      case 461: // Back
        window.removeEventListener("keydown", handleKeyDown);
        callBack("AnimatedGrid", true);
        break;
      default:
        break;
    }
  };

  const handleBack = () => {
    window.removeEventListener("keydown", handleKeyDown);
    callBack("AnimatedGrid", true);
  };

  setFocusToDefault = () => {
    setCurrentRowIndex(0);
    setSelectedIndex({ row: 0, col: 0 });
    setScrollOffsets({});
    setVerticalScrollOffset(0);
    setState((prevState) => ({
      ...prevState,
      hasBackButtonFocus: false,
    }));
  };

  RemoveCurrentKeyListener = () => {
    keyListenerRef.current = null;
    keyListenerRef.current = handleKeyDown;
    window.addEventListener("keydown", keyListenerRef.current);
  };

  addKeyListener = () => {
    if (keyListenerRef.current) return;
    keyListenerRef.current = handleKeyDown;
    window.addEventListener("keydown", keyListenerRef.current);
  };

  const removeKeyListener = () => {
    if (!keyListenerRef.current) return;
    window.removeEventListener("keydown", keyListenerRef.current);
    keyListenerRef.current = null;
  };

  const selectDown = () => {
    if (currentRowIndex < data.length - 1) {
      const nextRowIndex = currentRowIndex + 1;

      setScrolling(true);
      setCurrentRowIndex(nextRowIndex);
      setSelectedIndex({ row: nextRowIndex, col: 0 });

      // Reset horizontal scroll offset for new row if not set
      if (scrollOffsets[nextRowIndex] === undefined) {
        setScrollOffsets((prev) => ({ ...prev, [nextRowIndex]: 0 }));
      }

      // Vertical scroll - keep current row visible (scroll after first row)
      if (nextRowIndex > 0 && nextRowIndex > verticalScrollOffset) {
        setVerticalScrollOffset(nextRowIndex > 0 ? nextRowIndex - 1 : 0);
      }

      setTimeout(() => setScrolling(false), scrollDuration);
    }
  };

  const selectUp = () => {
    if (currentRowIndex > 0) {
      const prevRowIndex = currentRowIndex - 1;

      setScrolling(true);
      setCurrentRowIndex(prevRowIndex);
      setSelectedIndex({ row: prevRowIndex, col: 0 });

      if (scrollOffsets[prevRowIndex] === undefined) {
        setScrollOffsets((prev) => ({ ...prev, [prevRowIndex]: 0 }));
      }

      // Vertical scroll up
      if (prevRowIndex < verticalScrollOffset) {
        setVerticalScrollOffset(prevRowIndex);
      }

      setTimeout(() => setScrolling(false), scrollDuration);
    } else {
      setState((prevState) => ({
        ...prevState,
        hasBackButtonFocus: true,
      }));
    }
  };

  const selectRight = () => {
    const currentRow = data[currentRowIndex];
    if (!currentRow || !currentRow.list) return;

    const listLength = currentRow.list.length;
    const visibleColumnCount = getColumnCount(currentRowIndex);
    const currentOffset = getScrollOffset(currentRowIndex);
    const actualColIndex = currentOffset + selectedIndex.col;

    if (actualColIndex < listLength - 1) {
      const newVisibleCol = selectedIndex.col + 1;

      if (newVisibleCol < visibleColumnCount) {
        setSelectedIndex({ row: currentRowIndex, col: newVisibleCol });
      } else {
        if (currentOffset + visibleColumnCount < listLength) {
          setScrolling(true);
          setScrollOffsets((prev) => ({
            ...prev,
            [currentRowIndex]: currentOffset + 1,
          }));
          setTimeout(() => setScrolling(false), scrollDuration);
        }
      }
    }
  };

  const selectLeft = () => {
    const currentOffset = getScrollOffset(currentRowIndex);

    if (selectedIndex.col > 0) {
      setSelectedIndex({ row: currentRowIndex, col: selectedIndex.col - 1 });
    } else if (currentOffset > 0) {
      setScrolling(true);
      setScrollOffsets((prev) => ({
        ...prev,
        [currentRowIndex]: currentOffset - 1,
      }));
      setTimeout(() => setScrolling(false), scrollDuration);
    }
  };

  const handleViewAllClick = (selectedItem) => {
    setSourceContext(
      `${sourceContext}/All/(${data[currentRowIndex]?.id}/${data[currentRowIndex]?.title[0]?.content})`
    );

    let playlist_id = selectedItem.playlist_id;
    let playlist_name = data[currentRowIndex].title[0].content;
    let playlist_type_id = data[currentRowIndex].playlist_type_id;
    let playlist_type = data[currentRowIndex].playlist_type;

    let fetchContentPromise = getViewAllContent(selectedItem);

    fetchContentPromise.then(function (viewAllData) {
      const AppInAppData = data;
      const updatedViewAllData = {
        ...viewAllData,
        playlist_name,
        playlist_type_id,
        playlist_type,
        selectedItem,
        AppInAppData,
        currentRowIndex,
      };
      navigate("ViewAllScreen", updatedViewAllData);
    });

    fetchContentPromise.catch(function () {
      console.log("fetchContentPromise Catch");
    });
  };

  const handleOk = (rowIndex, colIndex) => {
    const currentRow = rowIndex !== undefined ? rowIndex : currentRowIndex;
    const visibleCol = colIndex !== undefined ? colIndex : selectedIndex.col;
    const actualCol = getScrollOffset(currentRow) + visibleCol;

    if (!data[currentRow] || !data[currentRow].list[actualCol]) {
      console.warn("Invalid selection");
      return;
    }

    const selectedItem = data[currentRow]?.list[actualCol];
    setIsAppInAppData(sourceContext);
    setSourceContext(
      `${sourceContext}/(${selectedItem?.id}/${selectedItem.title})`
    );

    if (!selectedItem) {
      console.warn("No valid selected item found.");
      return;
    }

    if (selectedItem.type_id === "view_all" && selectedItem.playlist_type_id) {
      handleViewAllClick(selectedItem);
      return;
    }

    if (data[currentRow].playlist_type_id === 11) {
      fetchData(selectedItem);
      if (hideRowlist) {
        hideRowlist();
      }
    } else {
      window.removeEventListener("keydown", handleKeyDown);
      navigateToScreen("HomeDetailsScreen", selectedItem);
    }
  };

  async function fetchData(selectedItem) {
    const userId = localStorage.getItem("profileId");
    const getCountry = localStorage.getItem("country");

    try {
      const gridResponse = await getHomeSectionAppinApp(selectedItem.id);
      let updatedGridData = handleViewAll(gridResponse.data);
      const processedGridData = processDataWithViewAllAtEnd(updatedGridData);

      if (gridResponse) {
        setState((prevState) => ({
          ...prevState,
          griddata: processedGridData,
          shouldFocusToGrid: true,
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    if (shouldFocus) {
      addKeyListener();
    } else {
      removeKeyListener();
    }
    return () => removeKeyListener();
  }, [
    shouldFocus,
    selectedIndex,
    scrolling,
    appinappData,
    hasBackButtonFocus,
    scrollOffsets,
    currentRowIndex,
    data,
    verticalScrollOffset,
  ]);

  const selectedStyle =
    selectionStyle === "border"
      ? {
          outline:
            shouldFocus && !hasBackButtonFocus
              ? `5px solid #fff`
              : `0px solid transparent`,
        }
      : { transform: "scale(1.1)" };

  function capitalizeFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const navigateToScreen = (p, p1) => {
    navigate(p, p1);
  };

  const AnimatedGrid_Navigate = (p) => {
    setState((prevState) => ({
      ...prevState,
      griddata: null,
      shouldFocusToGrid: false,
    }));
    window.removeEventListener("keydown", handleKeyDown);
    navigateScreen("HomePage");
  };

  // Get the item width based on playlist type
  const getItemWidth = (playlistType) => {
    if (
      playlistType === "aggregator" ||
      playlistType === "RecommededFeed" ||
      playlistType === "continue_watching" ||
      playlistType === "content_language" ||
      playlistType === "popular_genres"
    ) {
      return "430px";
    }
    if (playlistType === "trending") {
      return "240px";
    }
    return columnWidth;
  };

  // Get thumbnail source based on playlist type
  const getThumbnailSrc = (show, playlistType) => {
    switch (playlistType) {
      case "trending":
        return show.thumbnail || default_vertical_img;
      case "continue_watching":
        return show.detail_banner || show.poster_url || default_horizontal_img;
      case "content_language":
      case "popular_genres":
      case "aggregator":
        return show.thumbnail || default_horizontal_img;
      case "RecommededFeed":
        return show.poster_url || default_horizontal_img;
      default:
        return show.thumbnail || default_vertical_img;
    }
  };

  // Get visible rows based on vertical scroll
  const getVisibleRows = () => {
    if (!data) return [];
    const startIndex = verticalScrollOffset;
    const endIndex = Math.min(startIndex + visibleRowCount + 1, data.length);
    return data.slice(startIndex, endIndex).map((row, index) => ({
      ...row,
      actualIndex: startIndex + index,
    }));
  };

  const visibleRows = getVisibleRows();

  // Calculate row height with gap
  const totalRowHeight = rowHeight + gapY + 50; // 50 for title space

  // Show ErrorScreen if no valid data exists
  if (!data || data.length === 0) {
    return (
      <ErrorScreen
        errorIcon={errorIcon}
        bgcolor={"transparent"}
        disply="flex"
      />
    );
  }

  return (
    <div>
      {griddata ? (
        <AppInApp
          appinappData={appinappData}
          isChild={true}
          itemDetails={griddata}
          columnCount={resolution === "FHD" ? 7 : 7}
          rowHeight={resolution === "FHD" ? 373 : 249}
          rowWidth={"100%"}
          columnWidth={resolution === "FHD" ? 238 : 159}
          columnHeight={resolution === "FHD" ? 300 : 200}
          thumbnailWidth={resolution === "FHD" ? 228 : 142}
          thumbnailHeight={resolution === "FHD" ? 291 : 194}
          gapX={8.5}
          gapY={0}
          selectionColor={"#FF671F"}
          scrollDuration={100}
          defaultRowCount={1}
          horizontalScrollStartIndex={1}
          selectionStyle={"border"}
          gridContainerX={resolution === "FHD" ? "118px" : "79px"}
          gridContainerY={"65.5vh"}
          gridContainerWidth={"95vw"}
          gridContainerHeight={"90vh"}
          gridContainerBgColor={"transparent"}
          shouldFocus={shouldFocusToGrid}
          navigate={navigateToScreen}
          FocusHandler={FocusHandler}
          callBack={callBack}
          navigateScreen={AnimatedGrid_Navigate}
        />
      ) : (
        <div
          style={{
            position: "absolute",
            width: "100vw",
            height: "100vh",
            backgroundColor: "#000",
            overflow: "hidden",
            margin: "0px",
            backgroundImage: `url(${solidbackgroundimg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Back Button */}
          <Wrapper
            as="button"
            onMouseEnter={() => {
              if (hasBackButtonFocus) return;
              setState((prevState) => ({
                ...prevState,
                hasBackButtonFocus: true,
              }));
            }}
            style={{
              backgroundColor: "transparent",
              border: "none",
              marginLeft: "2rem",
              borderRadius: "1rem",
              aspectRatio: "1/1",
              cursor: "pointer",
              position: "absolute",
              top: "1.5rem",
              zIndex: 10,
              outline: hasBackButtonFocus ? "4px solid #EC008C" : "none",
            }}
            onClick={() => handleBack()}
          >
            <img src={backIcon} width={50} height={50} alt="Back" />
          </Wrapper>

          {/* Grid Container */}
          <div
            className="grid-parent-container"
            style={{
              position: "absolute",
              overflow: "hidden",
              backgroundColor: "transparent",
              top: resolution === "FHD" ? "100px" : "80px",
              left: gridContainerX,
              width: gridContainerWidth,
              height: `calc(100vh - ${
                resolution === "FHD" ? "120px" : "100px"
              })`,
            }}
          >
            <div
              id="grid"
              className="grid"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                width: rowWidth,
                transition: `transform ${scrollDuration}ms ease`,
              }}
            >
              {visibleRows.map((row, rowDisplayIndex) => {
                const actualRowIndex = row.actualIndex;
                const isCurrentRow = actualRowIndex === currentRowIndex;
                const visibleItems = getVisibleItems(actualRowIndex);
                const currentOffset = getScrollOffset(actualRowIndex);
                const playlistType = row.playlist_type;

                return (
                  <div
                    key={`row-${actualRowIndex}`}
                    id={`parentdiv-${actualRowIndex}`}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: resolution === "FHD" ? "30px" : "20px",
                    }}
                  >
                    {/* Row Title */}
                    <div
                      className="category-title"
                      style={{
                        textAlign: "left",
                        fontWeight: "bold",
                        color: "white",
                        marginLeft: resolution === "FHD" ? "10px" : "7px",
                        marginBottom: resolution === "FHD" ? "15px" : "10px",
                        fontSize: resolution === "FHD" ? "24px" : "18px",
                      }}
                    >
                      {row.title &&
                      row.title.length > 0 &&
                      row.title[0]?.content
                        ? capitalizeFirstLetter(
                            row.title.find(
                              (item) =>
                                item.language ===
                                localStorage.getItem("AppLanguage")
                            )?.content ||
                              row.title[0]?.content ||
                              ""
                          )
                        : ""}
                    </div>

                    {/* Row Items */}
                    <div
                      className={`grid-row grid-row-${actualRowIndex}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        height: columnHeight,
                        gap: `${gapX}px`,
                        transition: `transform ${scrollDuration}ms ease`,
                      }}
                    >
                      {visibleItems.map((show, visibleColIndex) => {
                        const actualColIndex = currentOffset + visibleColIndex;
                        const isSelected =
                          isCurrentRow &&
                          selectedIndex.col === visibleColIndex &&
                          !hasBackButtonFocus;
                        const itemWidth = getItemWidth(playlistType);

                        return (
                          <div
                            key={`${actualRowIndex}-${actualColIndex}`}
                            className={`grid-item ${
                              isSelected ? "selected" : ""
                            }`}
                            style={{
                              width: itemWidth,
                              height: columnHeight,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "transparent",
                              position: "relative",
                              borderRadius: "10px",
                              flexShrink: 0,
                            }}
                          >
                            {/* Continue Watching Progress Bar */}
                            {playlistType === "continue_watching" && (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "6px",
                                  left: "0px",
                                  width: "100%",
                                  height: "12px",
                                  backgroundColor: "#444",
                                  borderRadius: "6px",
                                  overflow: "hidden",
                                  zIndex: 2,
                                }}
                              >
                                <div
                                  style={{
                                    width: `${
                                      show.video_duration && show.paused_at
                                        ? (show.paused_at /
                                            show.video_duration) *
                                          100
                                        : 0
                                    }%`,
                                    height: "100%",
                                    backgroundColor: "#EC008C",
                                    borderRadius: "3px",
                                  }}
                                />
                              </div>
                            )}

                            {/* Thumbnail Image */}
                            <Wrapper
                              as="img"
                              onMouseEnter={() => {
                                if (
                                  currentRowIndex === actualRowIndex &&
                                  selectedIndex.col === visibleColIndex &&
                                  !hasBackButtonFocus
                                )
                                  return;

                                setCurrentRowIndex(actualRowIndex);
                                setSelectedIndex({
                                  row: actualRowIndex,
                                  col: visibleColIndex,
                                });
                                setState((prevState) => ({
                                  ...prevState,
                                  hasBackButtonFocus: false,
                                }));
                              }}
                              onClick={() =>
                                handleOk(actualRowIndex, visibleColIndex)
                              }
                              src={getThumbnailSrc(show, playlistType)}
                              alt={show.title || "thumbnail"}
                              style={{
                                width:
                                  playlistType === "RecommededFeed" ||
                                  playlistType === "aggregator" ||
                                  playlistType === "popular_genres" ||
                                  playlistType === "continue_watching" ||
                                  playlistType === "content_language"
                                    ? "430px"
                                    : playlistType === "trending"
                                    ? "240px"
                                    : thumbnailWidth,
                                height: thumbnailHeight,
                                borderRadius: "10px",
                                objectFit: "fill",
                                ...(isSelected ? selectedStyle : {}),
                              }}
                            />

                            {/* View All Overlay */}
                            {show?.type_id === "view_all" && (
                              <img
                                src={view_all}
                                alt="View All"
                                style={{
                                  position: "absolute",
                                  width: "20rem",
                                  height: "27rem",
                                  pointerEvents: "none",
                                }}
                              />
                            )}

                            {/* Premium Icon */}
                            {show?.is_paid === 1 && (
                              <img
                                src={premium}
                                alt="Premium"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  width: "4rem",
                                  height: "4rem",
                                  pointerEvents: "none",
                                }}
                              />
                            )}

                            {/* Rent Icon */}
                            {show?.is_paid === 2 && (
                              <img
                                src={rent}
                                alt="Rent"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  width: "4rem",
                                  height: "4rem",
                                  pointerEvents: "none",
                                }}
                              />
                            )}

                            {/* Trending Numbers */}
                            {playlistType === "trending" &&
                              visibleColIndex < 10 && (
                                <img
                                  src={images[visibleColIndex]}
                                  alt={`Number ${visibleColIndex + 1}`}
                                  style={{
                                    position: "absolute",
                                    marginLeft: "-225px",
                                    marginTop: "230px",
                                    pointerEvents: "none",
                                  }}
                                />
                              )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

AppInAppListData.setFocus = (focus) => {
  addKeyListener();
};

AppInAppListData.setFocusDefault = () => {
  setFocusToDefault();
};

AppInAppListData.clearCurrentKeyListener = () => {
  RemoveCurrentKeyListener();
};

export default AppInAppListData;